/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import BN from 'bignumber.js';
import cn from 'classnames';
import theme from '../../../../../theme';
// TODO: move to utils
import { formatToken, formatDollars } from '../../../../../helpers/token-helper';
import s from '../item.module.scss';
import { useGetTheme } from '../../../../../hooks/useGetTheme';
import { OM } from '../../../../../constants/blockchain-constants';
import PolygonLogo from '../../../../../external/components/Icon/polygon';
import {
  ColumnTotalStakedAmountTitle,
  ColumnTotalStakedAmount,
  ColumnStatusTitle,
  ColumnEstimatedAprTitle,
  ColumnEstimatedDailyRewardsTitle,
  ColumnEarnedRewardsTitle,
} from '../../../../../components/Stake/column';

const PolyLogo = styled(PolygonLogo)`
  width: 34px;
  height: 34px;
  margin-right: 0.25rem;
  margin-left: 0.25rem;
`;

const MerkleAirdropItem = ({ isActive, onClick, polkadotData }) => {
  const colors = useGetTheme();

  const getWrapBgColor = () => ({ style: { backgroundColor: colors.listAssetBackground } });

  const { unclaimedAmount, usdPrice } = useSelector((state) => ({
    ...state.delegator.matic,
    usdPrice: state.basic.currency.USD[OM],
  }));

  const airgrabBalanceInUSD = new BN(unclaimedAmount).times(usdPrice).toFixed(0, BN.ROUND_DOWN);

  return (
    <div className={cn(s.wrap, { [s.active]: isActive })} {...getWrapBgColor()} onClick={onClick}>
      <ColumnTotalStakedAmountTitle isMobile />
      <div className={s.col}>
        <ColumnTotalStakedAmount
          title={'Delegator Rewards'}
          componentIcon={<PolyLogo />}
          usdPrice={formatDollars(airgrabBalanceInUSD)}
        />
        <div />
      </div>
      <ColumnStatusTitle isMobile />
      <div className={cn(s.col, s.colColumn)} style={{ color: theme.palette.mantra.pink }}>
        {unclaimedAmount > 0 ? 'Ready to claim' : ''}
      </div>
      <ColumnEstimatedAprTitle isMobile />
      <div className={s.col}></div>
      <ColumnEstimatedDailyRewardsTitle isMobile />
      <div className={s.col}></div>
      <ColumnEarnedRewardsTitle isMobile />
      <div className={s.col} style={{ color: theme.palette.mantra.pink }}>
        {unclaimedAmount > 0 ? formatToken(unclaimedAmount) + ' OM' : 0}
      </div>
    </div>
  );
};

MerkleAirdropItem.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  merkleAirdrop: PropTypes.object.isRequired,
};

export default connect((state) => ({
  maticAirdropData: state.delegator.matic,
}))(MerkleAirdropItem);
